(() => {
  /*
  * Collection Swatch Memory
  *
  * @description Maintains selected swatches when returning to a collection page
  *
  *  `collectionScroll` object is made in `collection-scroll-memory.js`
  *  `collectionScroll.selectedSwatches` is an array of objects made in `collection-product-card.js` with the following properties:
  *    - swatchId: The product id of the swatch
  *    - swatchElement: The element of the swatch
  *
  */

  // Restore selected swatches
  if(!sessionStorage.getItem('collectionScroll')) return
  const collectionScroll = JSON.parse(sessionStorage.getItem('collectionScroll'))
  if(window.location.href !== collectionScroll.url) return

  if (collectionScroll.selectedSwatches && collectionScroll.selectedSwatches.length > 0) {
    collectionScroll.selectedSwatches.forEach(swatch => {
      const swatchElement = document.querySelector(swatch.swatchId).querySelector(swatch.swatchElement)
      if (swatchElement) {
        swatchElement.click();
      }
    });
  }
})()